import React from 'react';

const Loading = () => <img className="spinner" src="https://static.cdn.gallerymediagroup.com/purewow/images/purewow-loader.gif" alt="Loading gif" />;

export default Loading;
